<script>
  export let onClick = () => {};
</script>

<div
  class="tw-absolute tw-w-full tw-left-0 tw-top-0 tw-bg-black tw-bg-opacity-50 tw-w-full tw-h-screen tw-z-30 tw-cursor-default"
  on:click|stopPropagation={onClick}
/>
